/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type TimeSlot = "T_00_00" | "T_00_30" | "T_01_00" | "T_01_30" | "T_02_00" | "T_02_30" | "T_03_00" | "T_03_30" | "T_04_00" | "T_04_30" | "T_05_00" | "T_05_30" | "T_06_00" | "T_06_30" | "T_07_00" | "T_07_30" | "T_08_00" | "T_08_30" | "T_09_00" | "T_09_30" | "T_10_00" | "T_10_30" | "T_11_00" | "T_11_30" | "T_12_00" | "T_12_30" | "T_13_00" | "T_13_30" | "T_14_00" | "T_14_30" | "T_15_00" | "T_15_30" | "T_16_00" | "T_16_30" | "T_17_00" | "T_17_30" | "T_18_00" | "T_18_30" | "T_19_00" | "T_19_30" | "T_20_00" | "T_20_30" | "T_21_00" | "T_21_30" | "T_22_00" | "T_22_30" | "T_23_00" | "T_23_30" | "%future added value";
export type DayTimeSlotInput = {
    date: string;
    timeSlot: TimeSlot;
};
export type ProfileUserSummaryRendererQueryVariables = {
    orgRelayId: string;
    calendarId: string;
    calendarIds: Array<string | null>;
    timeZone: string;
    rangeMin: DayTimeSlotInput;
    rangeMax: DayTimeSlotInput;
};
export type ProfileUserSummaryRendererQueryResponse = {
    readonly org: {
        readonly " $fragmentRefs": FragmentRefs<"ProfileUserSummary_org">;
    } | null;
};
export type ProfileUserSummaryRendererQuery = {
    readonly response: ProfileUserSummaryRendererQueryResponse;
    readonly variables: ProfileUserSummaryRendererQueryVariables;
};



/*
query ProfileUserSummaryRendererQuery(
  $orgRelayId: ID!
  $calendarId: String!
  $calendarIds: [String]!
  $timeZone: String!
  $rangeMin: DayTimeSlotInput!
  $rangeMax: DayTimeSlotInput!
) {
  org: node(id: $orgRelayId) {
    __typename
    ... on Org {
      ...ProfileUserSummary_org_1XTkGV
    }
    id
  }
}

fragment AvatarPerson_org on Org {
  id
}

fragment AvatarPerson_person on Person {
  __typename
  id
  emails
  primaryEmail
  isYou
  userId
  isUser
  profile {
    givenName
    familyName
    externalImageUrl
  }
}

fragment CalendarStatus_calendarStatus on CalendarStatus {
  status
  moonPhase
}

fragment CalendarStatus_person on Person {
  profile {
    givenName
  }
}

fragment CalendarStatus_profileTimeZone on ProfileTimeZone {
  timeZone
  userId
  calendarId
}

fragment ProfileUserSummary_org_1XTkGV on Org {
  ...AvatarPerson_org
  id
  experiments
  personsByCalendarIdsErrorable(calendarIds: $calendarIds) {
    __typename
    ... on PersonList {
      list {
        ...AvatarPerson_person
        ...CalendarStatus_person
        id
        emails
        primaryEmail
        profile {
          givenName
          familyName
          externalImageUrl
        }
        isYou
        isUser
      }
    }
  }
  calendarStatusErrorable(calendarId: $calendarId, timeZone: $timeZone) {
    __typename
    ... on CalendarStatus {
      ...CalendarStatus_calendarStatus
    }
    ... on GraphEntityError {
      message
      statusCode
    }
    ... on Node {
      __isNode: __typename
      id
    }
  }
  profileTimeZonesErrorable(calendarIds: $calendarIds) {
    __typename
    ... on ProfileTimeZoneList {
      list {
        ...CalendarStatus_profileTimeZone
      }
    }
    ... on GraphEntityError {
      message
      statusCode
    }
  }
  collaboratorStatsErrorable(calendarId: $calendarId, timeZone: $timeZone, rangeMin: $rangeMin, rangeMax: $rangeMax) {
    __typename
    ... on GraphEntityError {
      statusCode
    }
    ... on CollaboratorStats {
      calendarId
    }
  }
  suggestedInvites(first: 1000000) {
    edges {
      node {
        targetCalendarId
        id
      }
    }
  }
  pendingInvites(first: 1000000) {
    edges {
      node {
        targetCalendarId
        id
      }
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "calendarId"
    } as any, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "calendarIds"
    } as any, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "orgRelayId"
    } as any, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "rangeMax"
    } as any, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "rangeMin"
    } as any, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "timeZone"
    } as any, v6 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "orgRelayId"
        } as any
    ], v7 = {
        "kind": "Variable",
        "name": "calendarId",
        "variableName": "calendarId"
    } as any, v8 = {
        "kind": "Variable",
        "name": "calendarIds",
        "variableName": "calendarIds"
    } as any, v9 = {
        "kind": "Variable",
        "name": "rangeMax",
        "variableName": "rangeMax"
    } as any, v10 = {
        "kind": "Variable",
        "name": "rangeMin",
        "variableName": "rangeMin"
    } as any, v11 = {
        "kind": "Variable",
        "name": "timeZone",
        "variableName": "timeZone"
    } as any, v12 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    } as any, v13 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any, v14 = [
        (v8 /*: any*/)
    ], v15 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "userId",
        "storageKey": null
    } as any, v16 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "statusCode",
        "storageKey": null
    } as any, v17 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "message",
                "storageKey": null
            },
            (v16 /*: any*/)
        ],
        "type": "GraphEntityError",
        "abstractKey": null
    } as any, v18 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "calendarId",
        "storageKey": null
    } as any, v19 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000000
        } as any
    ], v20 = [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "targetCalendarId",
            "storageKey": null
        } as any,
        (v13 /*: any*/)
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                (v0 /*: any*/),
                (v1 /*: any*/),
                (v2 /*: any*/),
                (v3 /*: any*/),
                (v4 /*: any*/),
                (v5 /*: any*/)
            ],
            "kind": "Fragment",
            "metadata": null,
            "name": "ProfileUserSummaryRendererQuery",
            "selections": [
                {
                    "alias": "org",
                    "args": (v6 /*: any*/),
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "args": [
                                        (v7 /*: any*/),
                                        (v8 /*: any*/),
                                        (v9 /*: any*/),
                                        (v10 /*: any*/),
                                        (v11 /*: any*/)
                                    ],
                                    "kind": "FragmentSpread",
                                    "name": "ProfileUserSummary_org"
                                }
                            ],
                            "type": "Org",
                            "abstractKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                (v2 /*: any*/),
                (v0 /*: any*/),
                (v1 /*: any*/),
                (v5 /*: any*/),
                (v4 /*: any*/),
                (v3 /*: any*/)
            ],
            "kind": "Operation",
            "name": "ProfileUserSummaryRendererQuery",
            "selections": [
                {
                    "alias": "org",
                    "args": (v6 /*: any*/),
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        (v12 /*: any*/),
                        (v13 /*: any*/),
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "experiments",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": (v14 /*: any*/),
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "personsByCalendarIdsErrorable",
                                    "plural": false,
                                    "selections": [
                                        (v12 /*: any*/),
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Person",
                                                    "kind": "LinkedField",
                                                    "name": "list",
                                                    "plural": true,
                                                    "selections": [
                                                        (v12 /*: any*/),
                                                        (v13 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "emails",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "primaryEmail",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "isYou",
                                                            "storageKey": null
                                                        },
                                                        (v15 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "isUser",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "UserProfile",
                                                            "kind": "LinkedField",
                                                            "name": "profile",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "givenName",
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "familyName",
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "externalImageUrl",
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "type": "PersonList",
                                            "abstractKey": null
                                        }
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": [
                                        (v7 /*: any*/),
                                        (v11 /*: any*/)
                                    ],
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "calendarStatusErrorable",
                                    "plural": false,
                                    "selections": [
                                        (v12 /*: any*/),
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "status",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "moonPhase",
                                                    "storageKey": null
                                                }
                                            ],
                                            "type": "CalendarStatus",
                                            "abstractKey": null
                                        },
                                        (v17 /*: any*/),
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                (v13 /*: any*/)
                                            ],
                                            "type": "Node",
                                            "abstractKey": "__isNode"
                                        }
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": (v14 /*: any*/),
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "profileTimeZonesErrorable",
                                    "plural": false,
                                    "selections": [
                                        (v12 /*: any*/),
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "ProfileTimeZone",
                                                    "kind": "LinkedField",
                                                    "name": "list",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "timeZone",
                                                            "storageKey": null
                                                        },
                                                        (v15 /*: any*/),
                                                        (v18 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "type": "ProfileTimeZoneList",
                                            "abstractKey": null
                                        },
                                        (v17 /*: any*/)
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": [
                                        (v7 /*: any*/),
                                        (v9 /*: any*/),
                                        (v10 /*: any*/),
                                        (v11 /*: any*/)
                                    ],
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "collaboratorStatsErrorable",
                                    "plural": false,
                                    "selections": [
                                        (v12 /*: any*/),
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                (v16 /*: any*/)
                                            ],
                                            "type": "GraphEntityError",
                                            "abstractKey": null
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                (v18 /*: any*/)
                                            ],
                                            "type": "CollaboratorStats",
                                            "abstractKey": null
                                        }
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": (v19 /*: any*/),
                                    "concreteType": "SuggestedOrgInviteConnection",
                                    "kind": "LinkedField",
                                    "name": "suggestedInvites",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "SuggestedOrgInviteEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "SuggestedOrgInvite",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": (v20 /*: any*/),
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": "suggestedInvites(first:1000000)"
                                },
                                {
                                    "alias": null,
                                    "args": (v19 /*: any*/),
                                    "concreteType": "OrgInviteConnection",
                                    "kind": "LinkedField",
                                    "name": "pendingInvites",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "OrgInviteEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "OrgInvite",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": (v20 /*: any*/),
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": "pendingInvites(first:1000000)"
                                }
                            ],
                            "type": "Org",
                            "abstractKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "484eca5a9b414722b170f37c3ce1528a",
            "id": null,
            "metadata": {},
            "name": "ProfileUserSummaryRendererQuery",
            "operationKind": "query",
            "text": "query ProfileUserSummaryRendererQuery(\n  $orgRelayId: ID!\n  $calendarId: String!\n  $calendarIds: [String]!\n  $timeZone: String!\n  $rangeMin: DayTimeSlotInput!\n  $rangeMax: DayTimeSlotInput!\n) {\n  org: node(id: $orgRelayId) {\n    __typename\n    ... on Org {\n      ...ProfileUserSummary_org_1XTkGV\n    }\n    id\n  }\n}\n\nfragment AvatarPerson_org on Org {\n  id\n}\n\nfragment AvatarPerson_person on Person {\n  __typename\n  id\n  emails\n  primaryEmail\n  isYou\n  userId\n  isUser\n  profile {\n    givenName\n    familyName\n    externalImageUrl\n  }\n}\n\nfragment CalendarStatus_calendarStatus on CalendarStatus {\n  status\n  moonPhase\n}\n\nfragment CalendarStatus_person on Person {\n  profile {\n    givenName\n  }\n}\n\nfragment CalendarStatus_profileTimeZone on ProfileTimeZone {\n  timeZone\n  userId\n  calendarId\n}\n\nfragment ProfileUserSummary_org_1XTkGV on Org {\n  ...AvatarPerson_org\n  id\n  experiments\n  personsByCalendarIdsErrorable(calendarIds: $calendarIds) {\n    __typename\n    ... on PersonList {\n      list {\n        ...AvatarPerson_person\n        ...CalendarStatus_person\n        id\n        emails\n        primaryEmail\n        profile {\n          givenName\n          familyName\n          externalImageUrl\n        }\n        isYou\n        isUser\n      }\n    }\n  }\n  calendarStatusErrorable(calendarId: $calendarId, timeZone: $timeZone) {\n    __typename\n    ... on CalendarStatus {\n      ...CalendarStatus_calendarStatus\n    }\n    ... on GraphEntityError {\n      message\n      statusCode\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  profileTimeZonesErrorable(calendarIds: $calendarIds) {\n    __typename\n    ... on ProfileTimeZoneList {\n      list {\n        ...CalendarStatus_profileTimeZone\n      }\n    }\n    ... on GraphEntityError {\n      message\n      statusCode\n    }\n  }\n  collaboratorStatsErrorable(calendarId: $calendarId, timeZone: $timeZone, rangeMin: $rangeMin, rangeMax: $rangeMax) {\n    __typename\n    ... on GraphEntityError {\n      statusCode\n    }\n    ... on CollaboratorStats {\n      calendarId\n    }\n  }\n  suggestedInvites(first: 1000000) {\n    edges {\n      node {\n        targetCalendarId\n        id\n      }\n    }\n  }\n  pendingInvites(first: 1000000) {\n    edges {\n      node {\n        targetCalendarId\n        id\n      }\n    }\n  }\n}\n"
        }
    } as any;
})();
(node as any).hash = 'b50b8731dfc83dbf930b71ff67c1f277';
export default node;
